import { format } from "date-fns";

/**
 * Retorna um timestamp formatado para auditoria e logs.
 *
 * Padrão:
 * 01/02/2026 11:42:33
 */
function formatAuditTimestamp(date: Date = new Date()): string {
  return format(date, "dd/MM/yyyy HH:mm:ss");
}

export { formatAuditTimestamp };
